export default "__VITE_ASSET__D$O7Vk7A__"